export const conditions = [
    { rus: "Новое", en: "New", hebrew: "חדש" },
    { rus: "Идеальное", en: "Excellent", hebrew: "מצוין" },
    { rus: "Хорошее", en: "Good", hebrew: "טוב" },
    { rus: "Среднее", en: "Average", hebrew: "בינוני" },
    { rus: "Плохое", en: "Poor", hebrew: "גרוע" },
  ];